module.exports = __webpack_public_path__ + "img/hall-card-purple-tall.e5f73a40.png";